<template>
  <pui-spinner
    v-bind="$attrs"
    :message="$attrs.message || $t('common.overrides.progress.loading')"
    v-on="$listeners"
  >
    <!-- pass slots to child -->
    <template v-for="(_, slotIndex) of $scopedSlots" v-slot:[slotIndex]="slotProps">
      <slot :name="slotIndex" v-bind="slotProps" />
    </template>
  </pui-spinner>
</template>

<script>
export default {
  name: 'pui-common-spinner',
};
</script>
